import React from 'react';
import {Link} from "react-router-dom";
import PropTypes from "prop-types";

const ResourceNotFound = (props) => {

    return (
        <div className="container flex items-center justify-center">

            <div className="page-error" style={TB.createStyledCircle(TB.config("color.info"), 0.1)}>

                <div className="white-panel">
                    <h1>404</h1>

                    <h3>{props.type} not found</h3>

                    <p>The link you clicked may be broken or the page may have been renamed or removed.</p>
                    <Link
                        replace={true}
                        to={props.exitLink || TB.auth().appropriate()}
                        className="btn btn-primary mt-2">
                        {props.exitText || "Return to dashboard"}
                    </Link>
                </div>

            </div>
        </div>
    );
};
ResourceNotFound.defaultProps = {
    exitLink: undefined,
    exitText: "Return to dashboard",
}
ResourceNotFound.propTypes = {
    exitLink: PropTypes.any,
    exitText: PropTypes.any,
    type: PropTypes.string
};

export default ResourceNotFound;